






























import { Component, Vue, Watch } from 'vue-property-decorator'
import {AloCity} from '@/models/alo/AloCity'
import {AloAddress} from '@/models/alo/AloAddress'
import { ApiResultCode } from '@/enum/ApiResultCode'
import apiCity from '@/api/city'
import { directPayloadQuery } from '@/utils/api'

const searchSensibility = 300

@Component({  
  name: 'AddressEdit',    
  components: {      
  },
  props:{
    address:Object
  }
})
export default class AddressEdit extends Vue {
  
  address!: AloAddress
  villes = [] as Array<AloCity>    
  loadingCity  = false
  private _debounceId = -1

  private rules = {
    required: (value:any) => !!value || 'Champs requis'        
  }
  
  @Watch('address.adrPostalCode')
  onPostalCodeChange(newPostalCode: string) {    
    this.search()    
  }

 @Watch('address.ctyId')
 onCityChanged(newCityId: number) {    
  this.address.libelle = this.villes.find(v => v.id == newCityId)?.libelle??""
 }

  search(update = true) {   
    // cancel pending call
    clearTimeout(this._debounceId)
    this._debounceId = setTimeout(()=>{
      this.loadingCity = true
      directPayloadQuery(apiCity.findCity,this.address.adrPostalCode).then(cities => {
        this.villes = cities                 
        if(update && this.villes.length > 0) this.address.ctyId = this.villes[0].id    
      }).finally(() => {this.loadingCity = false})
    },update?searchSensibility:0)   
  }

  validate():boolean {
    //@ts-ignore
    return this.$refs.addressForm.validate()
  }

  mounted() {
    this.search(false)
  }
}
